import tailwindTheme from '../../../../config/tailwind.config';

// using this function in the Route page component on redesign branch
// a function to reorder array based on given startIndex and endIndex values
export const reorder = (list, startIndex, endIndex) => {
  const itemsResult = Array.from(list);
  const [removed] = itemsResult.splice(startIndex, 1);
  itemsResult.splice(endIndex, 0, removed);
  return itemsResult;
};

// using this function in the Route page component on redesign branch
// get Item Style function to set style during dragging
export const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  borderColor: isDragging ? tailwindTheme.theme.extend.colors['vamos-black'] : 'inherit',
  // styles we need to apply on draggables
  ...draggableStyle,
});

// get list style function to set style durring dragging
export const getListStyle = () => ({
  maxHeight: 350,
  overflowY: 'auto',
});
const grid = 3;

// get Item Style function to set style during dragging in Custom Field Edit form
export const getFormItemStyle = (isDragging, draggableStyle) => {
  const conditionalStyles = isDragging
    ? {
      background: 'white',
      borderBottom: 'none',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    }
    : {
      background: 'none',
      borderBottom: '1px solid #dee2e6',
      boxShadow: 'none',
    };

  return {
    userSelect: 'none',
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    borderRadius: '0.25rem',
    ...conditionalStyles,
    ...draggableStyle,
  };
};

// get list style function to set style during dragging in Custom Field Edit form
export const getFormListStyle = () => ({
  padding: grid,
});

// using this function to reorder items in Routes storybook component
export const onDragEnd = (result, items, setItems) => {
  if (!result.destination) {
    return;
  }
  // if item is dropped in same position
  if (result.destination.index === result.source.index) {
    return;
  }
  // get reordered items with new position we use -1 bc our positions start with 1 but index of array start with 0
  const reorderedItems = reorder(
    items,
    result.source.index,
    result.destination.index,
  );
  // set reordered items to state
  setItems(reorderedItems.map((item, index) => ({ ...item, position: index })));
};
